import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Badge/Badge.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Container"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Divider"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Divider/Divider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Group"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Group/Group.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Rating"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Rating/Rating.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Space"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Space/Space.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["EditionProductModale"] */ "/vercel/path0/src/components/EditionProductModale/EditionProductModale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Error/Error404.tsx");
